@for (organization of organizations; track organization.id) {
  <app-organization-free-trial-warning
    [organization]="organization"
    [includeOrganizationNameInMessaging]="true"
    (clicked)="navigateToPaymentMethod(organization.id)"
  >
  </app-organization-free-trial-warning>
}

<bit-banner
  id="update-browser-banner"
  bannerType="warning"
  *ngIf="visibleBanners.includes(VisibleVaultBanner.OutdatedBrowser)"
  (onClose)="dismissBanner(VisibleVaultBanner.OutdatedBrowser)"
>
  {{ "updateBrowserDesc" | i18n }}
  <a
    bitLink
    linkType="secondary"
    target="_blank"
    href="https://browser-update.org/update-browser.html"
    rel="noreferrer noopener"
  >
    {{ "updateBrowser" | i18n }}
  </a>
</bit-banner>

<bit-banner
  id="pending-auth-request-banner"
  bannerType="info"
  icon="bwi-info-circle"
  *ngIf="visibleBanners.includes(VisibleVaultBanner.PendingAuthRequest)"
  (onClose)="dismissBanner(VisibleVaultBanner.PendingAuthRequest)"
>
  {{ "youHaveAPendingLoginRequest" | i18n }}
  <a bitLink linkType="secondary" routerLink="/settings/security/device-management">
    {{ "reviewLoginRequest" | i18n }}
  </a>
</bit-banner>

<app-verify-email
  id="verify-email-banner"
  *ngIf="visibleBanners.includes(VisibleVaultBanner.VerifyEmail)"
  (onDismiss)="dismissBanner(VisibleVaultBanner.VerifyEmail)"
  (onVerified)="dismissBanner(VisibleVaultBanner.VerifyEmail)"
></app-verify-email>

<bit-banner
  id="premium-banner"
  bannerType="premium"
  *ngIf="premiumBannerVisible$ | async"
  (onClose)="dismissBanner(VisibleVaultBanner.Premium)"
>
  {{ "premiumUpgradeUnlockFeatures" | i18n }}
  <a bitLink linkType="secondary" routerLink="/settings/subscription/premium">
    {{ "goPremium" | i18n }}
  </a>
</bit-banner>
